import Text from 'components/Text/Text';
import React, { useContext } from 'react';
import {
	DishFullInfoContext,
	IDishFullInfoContext,
} from '../../../../../../../../../dishFullInfoState/dishFullInfoContext';
import style from './ModifierGroupsField.module.scss';

const ModifierGroupsField: React.FC = () => {
	const { dishForFullInfo } = useContext<IDishFullInfoContext>(DishFullInfoContext);

	return (
		<>
			<Text
				translationNameSpace="form"
				translationKey="modifierGroupCountLabel"
				translationOptions={{ count: dishForFullInfo?.modifierGroups.length }}
				theme="neutralLight"
				size="xs"
			/>
			<div className={style.groupsList}>
				{dishForFullInfo?.modifierGroups.length
					? dishForFullInfo.modifierGroups.map((el) => {
							return (
								<div key={el.modifierGroupId} className={style.item}>
									<div className={style.dot} />
									<Text translationKey={el.modifierGroupName} size="s" withTooltip={true} />
								</div>
							);
					  })
					: '-'}
			</div>
		</>
	);
};

export default ModifierGroupsField;
